"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/esnext.map.get-or-insert.js");
require("core-js/modules/esnext.map.get-or-insert-computed.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = require("@/utils/index");
var _index2 = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _index3 = _interopRequireDefault(require("@/components/Enabled/index.vue"));
var _productsVariations = require("@/api/products-variations");
var _licenseTc = require("@/api/master/licenseTc");
var _categories = require("@/api/categories");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.listLoading = true;
    this.total = 0;
    this.selectedVariations = [];
    this.rawList = [];
    this.industriesList = [];
    this.categoryList = [];
    this.licenseTcList = [];
    this.listQuery = {
      page: 1,
      limit: 30,
      enabled: true,
      relations: ['product_variation.licenseTc', 'licenseTc', 'licenseTcs', 'product.licenseTc', 'product.licenseTcs'],
      relation: ['product_variation.licenseTc', 'licenseTc', 'licenseTcs', 'product.licenseTc', 'product.licenseTcs'],
      join: ['product_variation.licenseTc', 'licenseTc', 'licenseTcs', 'product.licenseTc', 'product.licenseTcs'],
      'industries.id': undefined,
      'product.name': undefined,
      'product.enabled': true,
      productId: 0,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq',
        'industries.id': '$eq',
        'category.id': '$eq',
        'product.name': '$contL',
        'product.enabled': '$eq',
        productId: '$gt'
      }
    };
  }
  // Group flat list by product
  get groupedProducts() {
    const map = new Map();
    console.log('Grouping products from raw list:', this.rawList);
    let debugLogged = false;
    for (const item of this.rawList) {
      var _item$product, _variation$productsVa;
      const pId = (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.id;
      if (!map.has(pId)) {
        map.set(pId, {
          product: item.product,
          variations: []
        });
      }
      const variation = {
        ...item,
        ...(item.product_variation || {}),
        product: item.product
      };
      // Normalize licenseTc property from backend response (plural vs singular vs snake_case)
      /* eslint-disable camelcase */
      const rawLicense = variation.licenseTcs || variation.licenseTc || variation.license_tc || variation.license_tcs || ((_variation$productsVa = variation.productsVariation) === null || _variation$productsVa === void 0 ? void 0 : _variation$productsVa.licenseTc);
      /* eslint-enable camelcase */
      if (!debugLogged) {
        console.log('DEBUG VARIATION ITEM:', variation);
        console.log('DEBUG RAW LICENSE KEY:', rawLicense);
        debugLogged = true;
      }
      if (Array.isArray(rawLicense) && rawLicense.length) {
        var _rawLicense$;
        variation.licenseTc = rawLicense;
        // If it's an array of objects with ID
        if (typeof rawLicense[0] === 'object' && (_rawLicense$ = rawLicense[0]) !== null && _rawLicense$ !== void 0 && _rawLicense$.id) {
          variation.licenseTcId = rawLicense.map(tc => tc.id);
        } else if (typeof rawLicense[0] === 'number') {
          // If it's an array of numbers (IDs)
          variation.licenseTcId = rawLicense;
        }
      } else if (rawLicense && typeof rawLicense === 'object') {
        // Single object relation
        variation.licenseTc = [rawLicense];
        if (rawLicense.id) variation.licenseTcId = [rawLicense.id];
      }
      if (variation) {
        // attach parent product to variation object to preserve identity
        variation.product = item.product;
      }
      map.get(pId).variations.push(variation);
    }
    return Array.from(map.values());
  }
  isAlreadyAdded(variation) {
    const variationId = variation.productVariationId || variation.id;
    return !!variationId && this.addedVariationIds.some(id => String(id) === String(variationId));
  }
  isVariationDisabled(variation) {
    const noPrices = Number(variation.unitPrice) < 1 && Number(variation.salePrice) < 1 && Number(variation.quotePrice) < 1;
    return noPrices || this.isAlreadyAdded(variation);
  }
  formatPrice(variation) {
    const price = (variation.quotePrice || 0) > 0 ? variation.quotePrice : (variation.salePrice || 0) > 0 ? variation.salePrice : variation.unitPrice;
    return this.formatCurrency(price);
  }
  formatCurrency(value) {
    const amount = Number(value);
    const safeAmount = Number.isFinite(amount) ? amount : 0;
    return `₹${safeAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  }
  formatVariationLabel(variation) {
    const modelCode = this.getModelCode(variation);
    const certification = this.getLicenseTcName(variation);
    const label = [modelCode, certification].filter(Boolean).join(' - ');
    return label || '—';
  }
  getLicenseTcName(variation) {
    /* eslint-disable camelcase */
    const relation = (variation === null || variation === void 0 ? void 0 : variation.licenseTc) || (variation === null || variation === void 0 ? void 0 : variation.license_tc) || (variation === null || variation === void 0 ? void 0 : variation.licenseTC) || null;
    /* eslint-enable camelcase */
    const relationNames = Array.isArray(relation) ? relation.map(tc => {
      if (typeof tc === 'string') return tc.trim();
      if (typeof tc === 'number') return '';
      return ((tc === null || tc === void 0 ? void 0 : tc.name) || '').toString().trim();
    }).filter(Boolean) : relation && typeof relation === 'object' ? [(relation.name || '').toString().trim()].filter(Boolean) : typeof relation === 'string' && relation.trim() ? [relation.trim()] : [];
    if (relationNames.length) {
      return relationNames.join(', ');
    }
    /* eslint-disable camelcase */
    const licenseTcIds = (variation === null || variation === void 0 ? void 0 : variation.licenseTcId) || (variation === null || variation === void 0 ? void 0 : variation.licenseTcIds) || (variation === null || variation === void 0 ? void 0 : variation.license_tc_id) || (variation === null || variation === void 0 ? void 0 : variation.license_tc_ids) || [];
    /* eslint-enable camelcase */
    const ids = Array.isArray(licenseTcIds) ? licenseTcIds : licenseTcIds !== undefined && licenseTcIds !== null ? [licenseTcIds] : [];
    if (ids.length && this.licenseTcList.length) {
      const names = ids.map(id => {
        const match = this.licenseTcList.find(tc => String(tc.id) === String(id));
        return (match === null || match === void 0 ? void 0 : match.name) || '';
      }).filter(Boolean);
      if (names.length) {
        return names.join(', ');
      }
    }
    return '';
  }
  getModelCode(variation) {
    /* eslint-disable camelcase */
    const modelCode = ((variation === null || variation === void 0 ? void 0 : variation.modelCode) || (variation === null || variation === void 0 ? void 0 : variation.model_code) || (variation === null || variation === void 0 ? void 0 : variation.modelNo) || (variation === null || variation === void 0 ? void 0 : variation.model_number) || '').toString().trim();
    /* eslint-enable camelcase */
    if (modelCode) return modelCode;
    const variationName = ((variation === null || variation === void 0 ? void 0 : variation.name) || '').toString().trim();
    if (!variationName) return '';
    const compactName = variationName.replace(/\s+/g, ' ');
    const tailToken = compactName.split(' ').pop() || '';
    return /^[A-Za-z0-9-]+$/.test(tailToken) ? tailToken : '';
  }
  created() {
    this.getProductList();
    this.fetchCategoryList();
    this.fetchLicenseTcs();
  }
  scrollLeft() {
    const el = this.$refs.productScroll;
    if (el) {
      el.scrollBy({
        left: -320,
        behavior: 'smooth'
      });
    }
  }
  scrollRight() {
    const el = this.$refs.productScroll;
    if (el) {
      el.scrollBy({
        left: 320,
        behavior: 'smooth'
      });
    }
  }
  async getProductList() {
    try {
      this.listLoading = true;
      const data = await (0, _productsVariations.getVariationsList)(this.listQuery);
      this.rawList = data.data;
      this.total = data.total;
    } catch (error) {
      /* handle */
    } finally {
      this.listLoading = false;
    }
  }
  async fetchCategoryList() {
    try {
      const res = await (0, _categories.getCategories)((0, _index.getQuery)({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq'
        }
      }));
      this.categoryList = res;
    } catch (error) {/* handle */}
  }
  async fetchLicenseTcs() {
    try {
      const data = await (0, _licenseTc.getLicenseTcs)((0, _index.getQuery)({
        page: 1,
        limit: 1000,
        sort: 'name,ASC'
      }));
      this.licenseTcList = (data === null || data === void 0 ? void 0 : data.data) || data || [];
      console.log('License TCs loaded:', this.licenseTcList);
    } catch (error) {
      console.error('Failed to load License TCs:', error);
      this.licenseTcList = [];
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getProductList();
  }
  submitSelection() {
    console.log('Selected Variations:', this.selectedVariations);
    if (this.selectedVariations.length) {
      console.log('Emitting variations to parent:', this.selectedVariations);
      this.$emit('sendProductOptions', this.selectedVariations);
      // reset selection
      this.selectedVariations = [];
      console.log('Selection cleared');
    } else {
      console.log('No variation selected');
      this.$message({
        message: 'Please select at least one variation',
        type: 'warning'
      });
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: 0
})], default_1.prototype, "id", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: null
})], default_1.prototype, "lead", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: () => []
})], default_1.prototype, "addedVariationIds", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LeadsProductGrid',
  components: {
    Enabled: _index3.default,
    Pagination: _index2.default
  }
})], default_1);
var _default = exports.default = default_1;